// Accounting Tab Start
export const ACCOUNTING_TAB_BILLING = "Invoices";
export const ACCOUNTING_TAB_PAYMENTS = "Payments";
export const ACCOUNTING_TAB_PROMOTIONS = "Promotions";
// Accounting Tab End
